import { FC } from 'react';
import { GameCardContainerType } from '../../GameCard/GameCard.types';
import { Grid, GridItem } from '../../../shared/Grid';
import { useBreakpointInfo, MediaBreakpoint } from '../../../../hooks/useDeviceInfo';
import { renderGameCard, BaseLayoutProps } from '../utils';
import { HERO_LAYOUT_GAMES_COUNT } from '../../../../utils/games/createTileRowCollections';

type SimpleLayoutProps = BaseLayoutProps;

export const HeroLayout: FC<SimpleLayoutProps> = ({ games, ...props }) => {
  const isMobileDevice = useBreakpointInfo([MediaBreakpoint.BELOW_MID_DESKTOP]);

  if (games.length < HERO_LAYOUT_GAMES_COUNT) return null;

  const className = isMobileDevice ? 'game-grid game-grid--hero-mobile' : 'game-grid game-grid--hero';
  const [firstGame] = games;

  return (
    <Grid columns={2} gap="s" className={className}>
      <GridItem startCol={1} endCol={3} className="game-grid__hero-item">
        {renderGameCard(firstGame, GameCardContainerType.Box, 'hero', props)}
      </GridItem>
    </Grid>
  );
};
